let globalZIndexCounter = 100;

export const getNextZIndex = () => {
  const zIndex = globalZIndexCounter;
  globalZIndexCounter++;
  return zIndex;
};

export const resetZIndex = () => {
  globalZIndexCounter = 100;
}; 